













































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import Header from "@/components/Header.vue";
import {propertyTypes} from "@/services/properties";
import properties, {codes} from "@/services/properties/cpi-ppi";
import data, { selectChoices } from "@/services/data/cpi-ppi";
import categories from "@/services/categories";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import { isNil } from "ramda";
import { format } from "date-fns";
import TextField from "@/components/TextField.vue";
import TextArea from "@/components/TextArea.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import MultiComboBox from "@/components/MultiComboBox.vue";
import Frazionamento from "@/components/Frazionamento.vue";
import StringList from "@/components/StringList.vue";
import TextFieldSign from "@/components/TextFieldSign.vue";
import { PnetInput } from "@previnet/vue-input";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user'],
  components: {
    Header,
    TextField,
    ComboBox,
    DatePicker,
    MultiComboBox,
    Frazionamento,
    StringList,
    TextFieldSign,
    PnetInput,
    TextArea,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      modalErrorMsg: null as any,
      modalErrorTitle: null as any,
      ...properties,
      ...data,
      selectChoices,
      propertyTypes,
      it,
      ND: "n.d.",
      productIdSelected: this.$props.productId,
      propList: [] as any[],
      esitoRegistrazione: null as any,
      categories,
      precSettingRamo: {
        vita: undefined,
        danni: undefined,
      },
      massiveFile: undefined,
      massiveLoaded: false,
      massiveResult: null as any,
    };
  },
  methods: {
    isNil,
    scrollTo(refName: string) {
      var element = this.$refs[refName] as any;
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    formatDateF: function(data: Date | string, formatStr: string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, formatStr);
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home-prodotti', params: {user: vm.loggedUser}});
    },
    back: function() {
      const vm = this as any;
      vm.$router.go(-1);
    },
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();
        vm.preparePropList();

        if (vm.errorMsg == null && vm.propList.length > 0) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalMassivo: function() {
      const vm = this as any;
      vm.massiveFile = undefined;
      vm.massiveLoaded = false;
      vm.massiveResult = null;
      vm.$bvModal.show("modal-massive");
    },
    closeModalMassivo() {
      const vm = this as any;
      vm.$bvModal.hide("modal-massive");
    },
    openModalError(msg: any, title: any) {
      const vm = this as any;
      if (msg === undefined) {
        vm.modalErrorMsg = "Non è stato possibile salvare i dati.";
      } else {
        vm.modalErrorMsg = msg;
      }
      if (title === undefined) {
        vm.modalErrorTitle = "ERRORE";
      } else {
        vm.modalErrorTitle = title;
      }
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    multivaluesContain(multivalues: any, values: any) {
      if (multivalues != null && values != null) {
        return multivalues.filter(function(e: any) {
          return values.indexOf(e.code) >= 0;
        }).length > 0;
      }

      return false;
    },
    checkFields() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.prodottoProperty.value == undefined ||
        properties.prodottoProperty.value == null ||
        properties.prodottoProperty.value == ""
      ) {
        vm.errorMsg = "Il campo " + properties.prodottoProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.prodottoProperty.value + " registrato";
      }

      return retValue;
    },
    isRamoVita() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.ramo, ["13.1"]);
    },
    isRamoDanni() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.ramo, ["13.2"]);
    },
    initSettingRamo() {
      const vm = this as any;

      // valorizzazione iniziale
      if (vm.precSettingRamo.vita === undefined) {
        vm.precSettingRamo.vita = vm.isRamoVita();
      }
      if (vm.precSettingRamo.danni === undefined) {
        vm.precSettingRamo.danni = vm.isRamoDanni();
      }
    },
    changePiuTariffe() {
      const vm = this as any;

      if (selectChoices.piuTariffe.code == '2.2') {
        properties.codProdCollegatoProperty.value = vm.ND;
      } else {
        properties.codProdCollegatoProperty.value = "";
      }
    },
    changeFineComm() {
      const vm = this as any;
      
      properties.fineCommProperty.value = "";
      properties.fineCommProperty.dateValue = null;

      if (selectChoices.prodCommercio.code == "16.1") {
        properties.fineCommProperty.value = vm.ND;
      }
    },
    changePremioTipologia() {
      const vm = this as any;
      properties.frazPremioProperty.value = "";
      properties.interessiFrazProperty.value = "";

      if (!vm.multivaluesContain(selectChoices.premioTipologia, ["21.1"])) {
        selectChoices.frazPremio = [];
        properties.frazPremioProperty.value = vm.ND;
        properties.frazPremioProperty.values = [];

        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "%",
          bimestrale: "", bimestraleSign: "%",
          trimestrale: "", trimestraleSign: "%",
          quadrimestrale: "", quadrimestraleSign: "%",
          semestrale: "", semestraleSign: "%",
        };
      }
    },
    countFrazionamento(prop: any) {
      const vm = this as any;
      let count = 0;

      if (prop !== undefined && prop.frazionamento !== undefined) {
        const f = prop.frazionamento;
        if (f.mensile !== vm.ND) count++;
        if (f.bimestrale !== vm.ND) count++;
        if (f.trimestrale !== vm.ND) count++;
        if (f.quadrimestrale !== vm.ND) count++;
        if (f.semestrale !== vm.ND) count++;
      }

      return count;
    },
    isInteressiFrazionamentoND() {
      const vm = this as any;
      const isPremioAnnuo = vm.multivaluesContain(selectChoices.premioTipologia, ["21.1"]);
      const isNoFraz = vm.multivaluesContain(selectChoices.frazPremio, ["23.6"]);

      return !isPremioAnnuo || isNoFraz;
    },
    isFrazionamentoMensile() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.1"]);
    },
    isFrazionamentoBimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.2"]);
    },
    isFrazionamentoTrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.3"]);
    },
    isFrazionamentoQuadrimestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.4"]);
    },
    isFrazionamentoSemestrale() {
      const vm = this as any;

      return vm.multivaluesContain(selectChoices.frazPremio, ["23.5"]);
    },
    changeFrazPremio() {
      const vm = this as any;
      properties.interessiFrazProperty.value = "";

      if (selectChoices.frazPremio.length == 0 || vm.multivaluesContain(selectChoices.frazPremio, ["23.6"])) {
        properties.interessiFrazProperty.value = vm.ND;
        properties.interessiFrazProperty.frazionamento = {
          mensile: "", mensileSign: "%",
          bimestrale: "", bimestraleSign: "%",
          trimestrale: "", trimestraleSign: "%",
          quadrimestrale: "", quadrimestraleSign: "%",
          semestrale: "", semestraleSign: "%",
        };
      }
    },
    changeRamo() {
      const vm = this as any;
      
      const isChangedRamoVita = vm.precSettingRamo.vita != vm.isRamoVita();
      const isChangedRamoDanni = vm.precSettingRamo.danni != vm.isRamoDanni();

      vm.precSettingRamo.vita = vm.isRamoVita();
      vm.precSettingRamo.danni = vm.isRamoDanni();

      if (selectChoices.ramo.length == 0) {
        selectChoices.rischiAssicuratiRamoVita = [];
        properties.rischiAssicuratiRamoVitaProperty.value = vm.ND;
        properties.rischiAssicuratiRamoVitaProperty.values = [];

        selectChoices.rischiAssicuratiRamoDanni = [];
        properties.rischiAssicuratiRamoDanniProperty.value = vm.ND;
        properties.rischiAssicuratiRamoDanniProperty.values = [];

        properties.costiRamoVitaProperty.value = vm.ND;
        properties.costiRamoDanniProperty.value = vm.ND;

        properties.retrDistrVitaProperty.value = vm.ND;
        properties.retrDistrVitaProperty.valueSign = "";
        properties.retrDistrDanniProperty.value = vm.ND;
        properties.retrDistrDanniProperty.valueSign = "";
      } else {
        if (!vm.isRamoVita()) {
          selectChoices.rischiAssicuratiRamoVita = [];
          properties.rischiAssicuratiRamoVitaProperty.value = vm.ND;
          properties.rischiAssicuratiRamoVitaProperty.values = [];

          properties.costiRamoVitaProperty.value = vm.ND;
          properties.costiRamoVitaProperty.stringList = [];

          properties.retrDistrVitaProperty.value = vm.ND;
          properties.retrDistrVitaProperty.valueSign = "";
        } else if (isChangedRamoVita) {
          properties.rischiAssicuratiRamoVitaProperty.value = "";
          properties.costiRamoVitaProperty.value = "";
          properties.costiRamoVitaProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
          properties.retrDistrVitaProperty.value = "";
          properties.retrDistrVitaProperty.valueSign = "%";
        }

        if (!vm.isRamoDanni()) {
          selectChoices.rischiAssicuratiRamoDanni = [];
          properties.rischiAssicuratiRamoDanniProperty.value = vm.ND;
          properties.rischiAssicuratiRamoDanniProperty.values = [];

          properties.costiRamoDanniProperty.value = vm.ND;
          properties.costiRamoDanniProperty.stringList = [];

          properties.retrDistrDanniProperty.value = vm.ND;
          properties.retrDistrDanniProperty.valueSign = "";
        } else if (isChangedRamoDanni) {
          properties.rischiAssicuratiRamoDanniProperty.value = "";
          properties.costiRamoDanniProperty.value = "";
          properties.costiRamoDanniProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
          properties.retrDistrDanniProperty.value = "";
          properties.retrDistrDanniProperty.valueSign = "%";
        }
      }

      vm.changeRischiAssicurati();
    },
    changeRischiAssicurati() {
      const vm = this as any;

      if (selectChoices.rischiAssicuratiRamoVita.length == 0 &&
          selectChoices.rischiAssicuratiRamoDanni.length == 0) {
        selectChoices.decessoQualsiasiCausa.code = "30";
        selectChoices.decessoQualsiasiCausa.description = vm.ND;
        properties.decessoQualsiasiCausaProperty.code = "30";
        properties.decessoQualsiasiCausaProperty.value = vm.ND;
        properties.decessoQualsiasiCausaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.decessoDaInfortunio.code = "32";
        selectChoices.decessoDaInfortunio.description = vm.ND;
        properties.decessoDaInfortunioProperty.code = "32";
        properties.decessoDaInfortunioProperty.value = vm.ND;
        properties.decessoDaInfortunioPrestazioneProperty.value = vm.ND;
        //
        selectChoices.decessoDaMalattia.code = "34";
        selectChoices.decessoDaMalattia.description = vm.ND;
        properties.decessoDaMalattiaProperty.code = "34";
        properties.decessoDaMalattiaProperty.value = vm.ND;
        properties.decessoDaMalattiaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.invaliditaPermanenteQualsiasiCausa.code = "36";
        selectChoices.invaliditaPermanenteQualsiasiCausa.description = vm.ND;
        properties.invaliditaPermanenteQualsiasiCausaProperty.code = "36";
        properties.invaliditaPermanenteQualsiasiCausaProperty.value = vm.ND;
        properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.invaliditaPermanenteDaInfortunio.code = "38";
        selectChoices.invaliditaPermanenteDaInfortunio.description = vm.ND;
        properties.invaliditaPermanenteDaInfortunioProperty.code = "38";
        properties.invaliditaPermanenteDaInfortunioProperty.value = vm.ND;
        properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = vm.ND;
        //
        selectChoices.invaliditaPermanenteDaMalattia.code = "40";
        selectChoices.invaliditaPermanenteDaMalattia.description = vm.ND;
        properties.invaliditaPermanenteDaMalattiaProperty.code = "40";
        properties.invaliditaPermanenteDaMalattiaProperty.value = vm.ND;
        properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.inabilitaTemporaneaQualsiasiCausa.code = "42";
        selectChoices.inabilitaTemporaneaQualsiasiCausa.description = vm.ND;
        properties.inabilitaTemporaneaQualsiasiCausaProperty.code = "42";
        properties.inabilitaTemporaneaQualsiasiCausaProperty.value = vm.ND;
        properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.inabilitaTemporaneaDaInfortunio.code = "44";
        selectChoices.inabilitaTemporaneaDaInfortunio.description = vm.ND;
        properties.inabilitaTemporaneaDaInfortunioProperty.code = "44";
        properties.inabilitaTemporaneaDaInfortunioProperty.value = vm.ND;
        properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = vm.ND;
        //
        selectChoices.inabilitaTemporaneaDaMalattia.code = "46";
        selectChoices.inabilitaTemporaneaDaMalattia.description = vm.ND;
        properties.inabilitaTemporaneaDaMalattiaProperty.code = "46";
        properties.inabilitaTemporaneaDaMalattiaProperty.value = vm.ND;
        properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = vm.ND;
        //
        selectChoices.malattieGravi.code = "48";
        selectChoices.malattieGravi.description = vm.ND;
        properties.malattieGraviProperty.code = "48";
        properties.malattieGraviProperty.value = vm.ND;
        properties.malattieGraviPrestazioneProperty.value = vm.ND;
        //
        selectChoices.ricoveroOspedaliero.code = "50";
        selectChoices.ricoveroOspedaliero.description = vm.ND;
        properties.ricoveroOspedalieroProperty.code = "50";
        properties.ricoveroOspedalieroProperty.value = vm.ND;
        properties.ricoveroOspedalieroPrestazioneProperty.value = vm.ND;
        //
        selectChoices.ricoveroGrandeInterventoChirurgico.code = "52";
        selectChoices.ricoveroGrandeInterventoChirurgico.description = vm.ND;
        properties.ricoveroGrandeInterventoChirurgicoProperty.code = "52";
        properties.ricoveroGrandeInterventoChirurgicoProperty.value = vm.ND;
        properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = vm.ND;
        //
        selectChoices.perditaImpiego.code = "54";
        selectChoices.perditaImpiego.description = vm.ND;
        properties.perditaImpiegoProperty.code = "54";
        properties.perditaImpiegoProperty.value = vm.ND;
        properties.perditaImpiegoPrestazioneProperty.value = vm.ND;
        //
        properties.altriRischiProperty.value = vm.ND;
      } else {
        const decessoQualsiasiCausaDefaultCode = "30";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.1"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.1"])) {
          selectChoices.decessoQualsiasiCausa.code = decessoQualsiasiCausaDefaultCode;
          selectChoices.decessoQualsiasiCausa.description = vm.ND;
          properties.decessoQualsiasiCausaProperty.code = decessoQualsiasiCausaDefaultCode;
          properties.decessoQualsiasiCausaProperty.value = vm.ND;
          properties.decessoQualsiasiCausaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.decessoQualsiasiCausa.code == decessoQualsiasiCausaDefaultCode) {
          selectChoices.decessoQualsiasiCausa.description = "";
          properties.decessoQualsiasiCausaProperty.code = decessoQualsiasiCausaDefaultCode;
          properties.decessoQualsiasiCausaProperty.value = "";
          properties.decessoQualsiasiCausaPrestazioneProperty.value = "";
        }

        const decessoDaInfortunioDefaultCode = "32";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.2"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.2"])) {
          selectChoices.decessoDaInfortunio.code = decessoDaInfortunioDefaultCode;
          selectChoices.decessoDaInfortunio.description = vm.ND;
          properties.decessoDaInfortunioProperty.code = decessoDaInfortunioDefaultCode;
          properties.decessoDaInfortunioProperty.value = vm.ND;
          properties.decessoDaInfortunioPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.decessoDaInfortunio.code == decessoDaInfortunioDefaultCode) {
          selectChoices.decessoDaInfortunio.description = "";
          properties.decessoDaInfortunioProperty.code = decessoDaInfortunioDefaultCode;
          properties.decessoDaInfortunioProperty.value = "";
          properties.decessoDaInfortunioPrestazioneProperty.value = "";
        }

        const decessoDaMalattiaDefaultCode = "34";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.3"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.3"])) {
          selectChoices.decessoDaMalattia.code = decessoDaMalattiaDefaultCode;
          selectChoices.decessoDaMalattia.description = vm.ND;
          properties.decessoDaMalattiaProperty.code = decessoDaMalattiaDefaultCode;
          properties.decessoDaMalattiaProperty.value = vm.ND;
          properties.decessoDaMalattiaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.decessoDaMalattia.code == decessoDaMalattiaDefaultCode) {
          selectChoices.decessoDaMalattia.description = "";
          properties.decessoDaMalattiaProperty.code = decessoDaMalattiaDefaultCode;
          properties.decessoDaMalattiaProperty.value = "";
          properties.decessoDaMalattiaPrestazioneProperty.value = "";
        }

        const invaliditaPermanenteQualsiasiCausaDefaultCode = "36";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.4"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.4"])) {
          selectChoices.invaliditaPermanenteQualsiasiCausa.code = invaliditaPermanenteQualsiasiCausaDefaultCode;
          selectChoices.invaliditaPermanenteQualsiasiCausa.description = vm.ND;
          properties.invaliditaPermanenteQualsiasiCausaProperty.code = invaliditaPermanenteQualsiasiCausaDefaultCode;
          properties.invaliditaPermanenteQualsiasiCausaProperty.value = vm.ND;
          properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.invaliditaPermanenteQualsiasiCausa.code == invaliditaPermanenteQualsiasiCausaDefaultCode) {
          selectChoices.invaliditaPermanenteQualsiasiCausa.description = "";
          properties.invaliditaPermanenteQualsiasiCausaProperty.code = invaliditaPermanenteQualsiasiCausaDefaultCode;
          properties.invaliditaPermanenteQualsiasiCausaProperty.value = "";
          properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = "";
        }

        const invaliditaPermanenteDaInfortunioDefaultCode = "38";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.5"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.5"])) {
          selectChoices.invaliditaPermanenteDaInfortunio.code = invaliditaPermanenteDaInfortunioDefaultCode;
          selectChoices.invaliditaPermanenteDaInfortunio.description = vm.ND;
          properties.invaliditaPermanenteDaInfortunioProperty.code = invaliditaPermanenteDaInfortunioDefaultCode;
          properties.invaliditaPermanenteDaInfortunioProperty.value = vm.ND;
          properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.invaliditaPermanenteDaInfortunio.code == invaliditaPermanenteDaInfortunioDefaultCode) {
          selectChoices.invaliditaPermanenteDaInfortunio.description = "";
          properties.invaliditaPermanenteDaInfortunioProperty.code = invaliditaPermanenteDaInfortunioDefaultCode;
          properties.invaliditaPermanenteDaInfortunioProperty.value = "";
          properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = "";
        }

        const invaliditaPermanenteDaMalattiaDefaultCode = "40";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.6"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.6"])) {
          selectChoices.invaliditaPermanenteDaMalattia.code = invaliditaPermanenteDaMalattiaDefaultCode;
          selectChoices.invaliditaPermanenteDaMalattia.description = vm.ND;
          properties.invaliditaPermanenteDaMalattiaProperty.code = invaliditaPermanenteDaMalattiaDefaultCode;
          properties.invaliditaPermanenteDaMalattiaProperty.value = vm.ND;
          properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.invaliditaPermanenteDaMalattia.code == invaliditaPermanenteDaMalattiaDefaultCode) {
          selectChoices.invaliditaPermanenteDaMalattia.description = "";
          properties.invaliditaPermanenteDaMalattiaProperty.code = invaliditaPermanenteDaMalattiaDefaultCode;
          properties.invaliditaPermanenteDaMalattiaProperty.value = "";
          properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = "";
        }

        const inabilitaTemporaneaQualsiasiCausaDefaultCode = "42";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.7"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.7"])) {
          selectChoices.inabilitaTemporaneaQualsiasiCausa.code = inabilitaTemporaneaQualsiasiCausaDefaultCode;
          selectChoices.inabilitaTemporaneaQualsiasiCausa.description = vm.ND;
          properties.inabilitaTemporaneaQualsiasiCausaProperty.code = inabilitaTemporaneaQualsiasiCausaDefaultCode;
          properties.inabilitaTemporaneaQualsiasiCausaProperty.value = vm.ND;
          properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.inabilitaTemporaneaQualsiasiCausa.code == inabilitaTemporaneaQualsiasiCausaDefaultCode) {
          selectChoices.inabilitaTemporaneaQualsiasiCausa.description = "";
          properties.inabilitaTemporaneaQualsiasiCausaProperty.code = inabilitaTemporaneaQualsiasiCausaDefaultCode;
          properties.inabilitaTemporaneaQualsiasiCausaProperty.value = "";
          properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = "";
        }

        const inabilitaTemporaneaDaInfortunioDefaultCode = "44";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.8"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.8"])) {
          selectChoices.inabilitaTemporaneaDaInfortunio.code = inabilitaTemporaneaDaInfortunioDefaultCode;
          selectChoices.inabilitaTemporaneaDaInfortunio.description = vm.ND;
          properties.inabilitaTemporaneaDaInfortunioProperty.code = inabilitaTemporaneaDaInfortunioDefaultCode;
          properties.inabilitaTemporaneaDaInfortunioProperty.value = vm.ND;
          properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.inabilitaTemporaneaDaInfortunio.code == inabilitaTemporaneaDaInfortunioDefaultCode) {
          selectChoices.inabilitaTemporaneaDaInfortunio.description = "";
          properties.inabilitaTemporaneaDaInfortunioProperty.code = inabilitaTemporaneaDaInfortunioDefaultCode;
          properties.inabilitaTemporaneaDaInfortunioProperty.value = "";
          properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = "";
        }

        const inabilitaTemporaneaDaMalattiaDefaultCode = "46";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.9"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.9"])) {
          selectChoices.inabilitaTemporaneaDaMalattia.code = inabilitaTemporaneaDaMalattiaDefaultCode;
          selectChoices.inabilitaTemporaneaDaMalattia.description = vm.ND;
          properties.inabilitaTemporaneaDaMalattiaProperty.code = inabilitaTemporaneaDaMalattiaDefaultCode;
          properties.inabilitaTemporaneaDaMalattiaProperty.value = vm.ND;
          properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.inabilitaTemporaneaDaMalattia.code == inabilitaTemporaneaDaMalattiaDefaultCode) {
          selectChoices.inabilitaTemporaneaDaMalattia.description = "";
          properties.inabilitaTemporaneaDaMalattiaProperty.code = inabilitaTemporaneaDaMalattiaDefaultCode;
          properties.inabilitaTemporaneaDaMalattiaProperty.value = "";
          properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = "";
        }

        const malattieGraviDefaultCode = "48";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.10"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.10"])) {
          selectChoices.malattieGravi.code = malattieGraviDefaultCode;
          selectChoices.malattieGravi.description = vm.ND;
          properties.malattieGraviProperty.code = malattieGraviDefaultCode;
          properties.malattieGraviProperty.value = vm.ND;
          properties.malattieGraviPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.malattieGravi.code == malattieGraviDefaultCode) {
          selectChoices.malattieGravi.description = "";
          properties.malattieGraviProperty.code = malattieGraviDefaultCode;
          properties.malattieGraviProperty.value = "";
          properties.malattieGraviPrestazioneProperty.value = "";
        }

        const ricoveroOspedalieroDefaultCode = "50";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.11"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.11"])) {
          selectChoices.ricoveroOspedaliero.code = ricoveroOspedalieroDefaultCode;
          selectChoices.ricoveroOspedaliero.description = vm.ND;
          properties.ricoveroOspedalieroProperty.code = ricoveroOspedalieroDefaultCode;
          properties.ricoveroOspedalieroProperty.value = vm.ND;
          properties.ricoveroOspedalieroPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.ricoveroOspedaliero.code == ricoveroOspedalieroDefaultCode) {
          selectChoices.ricoveroOspedaliero.description = "";
          properties.ricoveroOspedalieroProperty.code = ricoveroOspedalieroDefaultCode;
          properties.ricoveroOspedalieroProperty.value = "";
          properties.ricoveroOspedalieroPrestazioneProperty.value = "";
        }

        const ricoveroGrandeInterventoChirurgicoDefaultCode = "52";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.12"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.12"])) {
          selectChoices.ricoveroGrandeInterventoChirurgico.code = ricoveroGrandeInterventoChirurgicoDefaultCode;
          selectChoices.ricoveroGrandeInterventoChirurgico.description = vm.ND;
          properties.ricoveroGrandeInterventoChirurgicoProperty.code = ricoveroGrandeInterventoChirurgicoDefaultCode;
          properties.ricoveroGrandeInterventoChirurgicoProperty.value = vm.ND;
          properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.ricoveroGrandeInterventoChirurgico.code == ricoveroGrandeInterventoChirurgicoDefaultCode) {
          selectChoices.ricoveroGrandeInterventoChirurgico.description = "";
          properties.ricoveroGrandeInterventoChirurgicoProperty.code = ricoveroGrandeInterventoChirurgicoDefaultCode;
          properties.ricoveroGrandeInterventoChirurgicoProperty.value = "";
          properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = "";
        }

        const perditaImpiegoDefaultCode = "54";
        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.13"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.13"])) {
          selectChoices.perditaImpiego.code = perditaImpiegoDefaultCode;
          selectChoices.perditaImpiego.description = vm.ND;
          properties.perditaImpiegoProperty.code = perditaImpiegoDefaultCode;
          properties.perditaImpiegoProperty.value = vm.ND;
          properties.perditaImpiegoPrestazioneProperty.value = vm.ND;
        } else if (selectChoices.perditaImpiego.code == perditaImpiegoDefaultCode) {
          selectChoices.perditaImpiego.description = "";
          properties.perditaImpiegoProperty.code = perditaImpiegoDefaultCode;
          properties.perditaImpiegoProperty.value = "";
          properties.perditaImpiegoPrestazioneProperty.value = "";
        }

        if (!vm.multivaluesContain(selectChoices.rischiAssicuratiRamoVita, ["28.14"]) &&
            !vm.multivaluesContain(selectChoices.rischiAssicuratiRamoDanni, ["29.14"])) {
          properties.altriRischiProperty.value = vm.ND;
        } else if (properties.altriRischiProperty.value == vm.ND) {
          properties.altriRischiProperty.value = "";
        }
      }
    },
    valorizzaTendine() {
      properties.piuTariffeProperty.code = selectChoices.piuTariffe.code;
      properties.piuTariffeProperty.value = selectChoices.piuTariffe.description;
      properties.compagniaProperty.values = selectChoices.compagnia
      properties.canaleProperty.values = selectChoices.canale;
      properties.modDistribuzioneProperty.values = selectChoices.modDistribuzione;
      properties.mercatoProperty.values = selectChoices.mercato;
      properties.ramoProperty.values = selectChoices.ramo;
      properties.tipologiaGaranzieProperty.values = selectChoices.tipologiaGaranzie;
      properties.prodCommercioProperty.code = selectChoices.prodCommercio.code;
      properties.prodCommercioProperty.value = selectChoices.prodCommercio.description;
      properties.tipologiaAssicurazioneProperty.code = selectChoices.tipologiaAssicurazione.code;
      properties.tipologiaAssicurazioneProperty.value = selectChoices.tipologiaAssicurazione.description;
      properties.premioTipologiaProperty.values = selectChoices.premioTipologia;
      properties.frazPremioProperty.values = selectChoices.frazPremio;
      properties.rischiAssicuratiRamoVitaProperty.values = selectChoices.rischiAssicuratiRamoVita;
      properties.rischiAssicuratiRamoDanniProperty.values = selectChoices.rischiAssicuratiRamoDanni;
      properties.decessoQualsiasiCausaProperty.code = selectChoices.decessoQualsiasiCausa.code;
      properties.decessoQualsiasiCausaProperty.value = selectChoices.decessoQualsiasiCausa.description;
      properties.decessoDaInfortunioProperty.code = selectChoices.decessoDaInfortunio.code;
      properties.decessoDaInfortunioProperty.value = selectChoices.decessoDaInfortunio.description;
      properties.decessoDaMalattiaProperty.code = selectChoices.decessoDaMalattia.code;
      properties.decessoDaMalattiaProperty.value = selectChoices.decessoDaMalattia.description;
      properties.invaliditaPermanenteQualsiasiCausaProperty.code = selectChoices.invaliditaPermanenteQualsiasiCausa.code;
      properties.invaliditaPermanenteQualsiasiCausaProperty.value = selectChoices.invaliditaPermanenteQualsiasiCausa.description;
      properties.invaliditaPermanenteDaInfortunioProperty.code = selectChoices.invaliditaPermanenteDaInfortunio.code;
      properties.invaliditaPermanenteDaInfortunioProperty.value = selectChoices.invaliditaPermanenteDaInfortunio.description;
      properties.invaliditaPermanenteDaMalattiaProperty.code = selectChoices.invaliditaPermanenteDaMalattia.code;
      properties.invaliditaPermanenteDaMalattiaProperty.value = selectChoices.invaliditaPermanenteDaMalattia.description;
      properties.inabilitaTemporaneaQualsiasiCausaProperty.code = selectChoices.inabilitaTemporaneaQualsiasiCausa.code;
      properties.inabilitaTemporaneaQualsiasiCausaProperty.value = selectChoices.inabilitaTemporaneaQualsiasiCausa.description;
      properties.inabilitaTemporaneaDaInfortunioProperty.code = selectChoices.inabilitaTemporaneaDaInfortunio.code;
      properties.inabilitaTemporaneaDaInfortunioProperty.value = selectChoices.inabilitaTemporaneaDaInfortunio.description;
      properties.inabilitaTemporaneaDaMalattiaProperty.code = selectChoices.inabilitaTemporaneaDaMalattia.code;
      properties.inabilitaTemporaneaDaMalattiaProperty.value = selectChoices.inabilitaTemporaneaDaMalattia.description;
      properties.malattieGraviProperty.code = selectChoices.malattieGravi.code;
      properties.malattieGraviProperty.value = selectChoices.malattieGravi.description;
      properties.ricoveroOspedalieroProperty.code = selectChoices.ricoveroOspedaliero.code;
      properties.ricoveroOspedalieroProperty.value = selectChoices.ricoveroOspedaliero.description;
      properties.ricoveroGrandeInterventoChirurgicoProperty.code = selectChoices.ricoveroGrandeInterventoChirurgico.code;
      properties.ricoveroGrandeInterventoChirurgicoProperty.value = selectChoices.ricoveroGrandeInterventoChirurgico.description;
      properties.perditaImpiegoProperty.code = selectChoices.perditaImpiego.code;
      properties.perditaImpiegoProperty.value = selectChoices.perditaImpiego.description;
    },
    cleanAllProperties() {
      properties.prodottoProperty.value = "";
      properties.piuTariffeProperty.code = ""; properties.piuTariffeProperty.value = "";
      properties.codProdCollegatoProperty.value = "";
      properties.compagniaProperty.values = [];
      properties.canaleProperty.values = [];
      properties.distributoriProperty.stringList = [{ value: "", valueSign: "" }],
      properties.modDistribuzioneProperty.values = [];
      properties.mercatoProperty.values = [];
      properties.destinatariProperty.value = "";
      properties.targetMarketProperty.value = "";
      properties.descProdottoProperty.value = "";
      properties.lineaBusinessProperty.value = "";
      properties.ramoProperty.values = [];
      properties.tipologiaGaranzieProperty.values = [];
      properties.combinazioneGaranzieProperty.value = "";
      properties.prodCommercioProperty.code = ""; properties.prodCommercioProperty.value = "";
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.edizioneDIPAggProperty.value = ""; properties.edizioneDIPAggProperty.dateValue = null;
      properties.tipologiaAssicurazioneProperty.code = ""; properties.tipologiaAssicurazioneProperty.value = "";
      properties.premioTipologiaProperty.values = [];
      properties.premioDescProperty.value = "";
      properties.frazPremioProperty.values = [];
      properties.durataProperty.value = "";
      properties.etaMaxAllaSottoscrizioneProperty.value = "";
      properties.etaMaxAllaScadenzaProperty.value = "";
      properties.docRichiestaProperty.value = "";
      properties.rischiAssicuratiRamoVitaProperty.values = [];
      properties.rischiAssicuratiRamoDanniProperty.values = [];
      properties.decessoQualsiasiCausaProperty.code = ""; properties.decessoQualsiasiCausaProperty.value = "";
      properties.decessoQualsiasiCausaPrestazioneProperty.value = "";
      properties.decessoDaInfortunioProperty.code = ""; properties.decessoDaInfortunioProperty.value = "";
      properties.decessoDaInfortunioPrestazioneProperty.value = "";
      properties.decessoDaMalattiaProperty.code = ""; properties.decessoDaMalattiaProperty.value = "";
      properties.decessoDaMalattiaPrestazioneProperty.value = "";
      properties.invaliditaPermanenteQualsiasiCausaProperty.code = ""; properties.invaliditaPermanenteQualsiasiCausaProperty.value = "";
      properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = "";
      properties.invaliditaPermanenteDaInfortunioProperty.code = ""; properties.invaliditaPermanenteDaInfortunioProperty.value = "";
      properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = "";
      properties.invaliditaPermanenteDaMalattiaProperty.code = ""; properties.invaliditaPermanenteDaMalattiaProperty.value = "";
      properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = "";
      properties.inabilitaTemporaneaQualsiasiCausaProperty.code = ""; properties.inabilitaTemporaneaQualsiasiCausaProperty.value = "";
      properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = "";
      properties.inabilitaTemporaneaDaInfortunioProperty.code = ""; properties.inabilitaTemporaneaDaInfortunioProperty.value = "";
      properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = "";
      properties.inabilitaTemporaneaDaMalattiaProperty.code = ""; properties.inabilitaTemporaneaDaMalattiaProperty.value = "";
      properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = "";
      properties.malattieGraviProperty.code = ""; properties.malattieGraviProperty.value = "";
      properties.malattieGraviPrestazioneProperty.value = "";
      properties.ricoveroOspedalieroProperty.code = ""; properties.ricoveroOspedalieroProperty.value = "";
      properties.ricoveroOspedalieroPrestazioneProperty.value = "";
      properties.ricoveroGrandeInterventoChirurgicoProperty.code = ""; properties.ricoveroGrandeInterventoChirurgicoProperty.value = "";
      properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = "";
      properties.perditaImpiegoProperty.code = ""; properties.perditaImpiegoProperty.value = "";
      properties.perditaImpiegoPrestazioneProperty.value = "";
      properties.altriRischiProperty.value = "";
      properties.speseEmissioneProperty.value = ""; properties.speseEmissioneProperty.valueSign = "€";
      properties.costiRamoVitaProperty.value = ""; properties.costiRamoVitaProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      properties.costiRamoDanniProperty.value = ""; properties.costiRamoDanniProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];
      properties.specificheCaricamentiProperty.value = "";
      properties.interessiFrazProperty.value = "";
      properties.interessiFrazProperty.frazionamento = {
        mensile: "", mensileSign: "%",
        bimestrale: "", bimestraleSign: "%",
        trimestrale: "", trimestraleSign: "%",
        quadrimestrale: "", quadrimestraleSign: "%",
        semestrale: "", semestraleSign: "%",
      };
      properties.altriCostiProperty.value = "";
      properties.retrDistrVitaProperty.value = "";
      properties.retrDistrDanniProperty.value = "";
      properties.retrDistrSpecificheProperty.value = "";
      properties.noteProperty.value = "";

      selectChoices.piuTariffe = { code: "", description: "" };
      selectChoices.compagnia = [];
      selectChoices.canale = [];
      selectChoices.modDistribuzione = [];
      selectChoices.mercato = [];
      selectChoices.ramo = [];
      selectChoices.tipologiaGaranzie = [];
      selectChoices.prodCommercio = { code: "", description: "" };
      selectChoices.tipologiaAssicurazione = { code: "", description: "" };
      selectChoices.premioTipologia = [];
      selectChoices.frazPremio = [];
      selectChoices.rischiAssicuratiRamoVita = [];
      selectChoices.rischiAssicuratiRamoDanni = [];
      selectChoices.decessoQualsiasiCausa = { code: "", description: "" };
      selectChoices.decessoDaInfortunio = { code: "", description: "" };
      selectChoices.decessoDaMalattia = { code: "", description: "" };
      selectChoices.invaliditaPermanenteQualsiasiCausa = { code: "", description: "" };
      selectChoices.invaliditaPermanenteDaInfortunio = { code: "", description: "" };
      selectChoices.invaliditaPermanenteDaMalattia = { code: "", description: "" };
      selectChoices.inabilitaTemporaneaQualsiasiCausa = { code: "", description: "" };
      selectChoices.inabilitaTemporaneaDaInfortunio = { code: "", description: "" };
      selectChoices.inabilitaTemporaneaDaMalattia = { code: "", description: "" };
      selectChoices.malattieGravi = { code: "", description: "" };
      selectChoices.ricoveroOspedaliero = { code: "", description: "" };
      selectChoices.ricoveroGrandeInterventoChirurgico = { code: "", description: "" };
      selectChoices.perditaImpiego = { code: "", description: "" };
    },
    setPropertiesDefaultCode() {
      const vm = this as any;

      if (properties.piuTariffeProperty.code == "") { properties.piuTariffeProperty.code = codes.piuTariffeProperty; }
      if (properties.prodCommercioProperty.code == "") { properties.prodCommercioProperty.code = codes.prodCommercioProperty; }
      if (properties.tipologiaAssicurazioneProperty.code == "") { properties.tipologiaAssicurazioneProperty.code = codes.tipologiaAssicurazioneProperty; }
    },
    prefillCodeValue: function(property: any, propCode: string, propValue: string, choices: any, options: any []) {
      property.code = propCode;
      property.value = propValue;
      if (propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        choices = { code: propCode, description: v ? v.description : propValue };
      } else if (propCode.length > 0) {
        choices = { code: propCode, description: propValue };
      } else {
        choices = { code: '', description: '' };
      }

      return choices;
    },
    /*prefillCodeValue1: function(property: any, propCode: string, propValue: string, choices: any, options: any []) {
      property.code = propCode;
      property.value = propValue;
      alert(property.code + " " + property.value);
      if (propCode.match(/\./)) {
        const v = options.find((o: any) => o.code === propCode);
        choices = { code: propCode, description: v ? v.description : propValue };
        alert("A --> " + JSON.stringify(choices));
      } else if (propCode.length > 0) {
        choices = { code: propCode, description: propValue };
        alert("B --> " + JSON.stringify(choices));
      } else {
        choices = { code: '', description: '' };
        alert("C --> " + JSON.stringify(choices));
      }

      return choices;
    },*/
    prefillValues: function(property: any, values: any [], choices: any, options: any []) {
      property.values = values;
      if (values.length > 0) {
        choices = [];
        for (let i = 0; i < values.length; i++) {
          const v = options.find((o: any) => o.code === values[i].code);
          choices.push({ code: v.code, description: v.description});
        }
      } else {
        choices = [];
      }

      return choices;
    },
    prefillProperties: async function() {
      const vm = this as any;

      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            let get = function(key: string, code: string) {
              let res = undefined;
              const regexCode = /^([0-9]+)([a-z]*)/i;
              let codePrefix = undefined;
              let codeSuffix = undefined;
              const codeMatch = regexCode.exec(code);
              let re: any = undefined;
              if (codeMatch) {
                codePrefix = codeMatch[1] || "";
                codeSuffix = codeMatch[2] || "";
                re = new RegExp(`^${codePrefix}\\.[0-9]${codeSuffix}`);
              }
              const p = result.properties.find((p: any) => {
                let match = false;
                const equals = p.code === code;
                if (!equals && re != undefined) {
                  match = re.test(p.code);
                }

                return equals || match;
              });
              if (p != undefined) {
                res = p[key];
              }
              return res;
            }

            const prodotto = get("value", codes.prodottoProperty);
            const piuTariffeCode = get("code", codes.piuTariffeProperty);
            const piuTariffeValue = get("value", codes.piuTariffeProperty);
            const codProdottiCollegati = get("value", codes.codProdCollegatoProperty);
            const compagniaValues = get("values", codes.compagniaProperty);
            const canaleValues = get("values", codes.canaleProperty);
            const distributoriStringList = get("stringList", codes.distributoriProperty);
            const modDistribuzioneValues = get("values", codes.modDistribuzioneProperty);
            const mercatoValues = get("values", codes.mercatoProperty);
            const destinatari = get("value", codes.destinatariProperty);
            const targetMarket = get("value", codes.targetMarketProperty);
            const descProdotto = get("value", codes.descProdottoProperty);
            const lineaBusiness = get("value", codes.lineaBusinessProperty);
            const ramoValues = get("values", codes.ramoProperty);
            const tipologiaGaranzieValues = get("values", codes.tipologiaGaranzieProperty);
            const combinazioneGaranzie = get("value", codes.combinazioneGaranzieProperty);
            const prodCommercioCode = get("code", codes.prodCommercioProperty);
            const prodCommercioValue = get("value", codes.prodCommercioProperty);
            const inizioComm = get("value", codes.inizioCommProperty);
            const fineComm = get("value", codes.fineCommProperty);
            const edizioneDIPAgg = get("value", codes.edizioneDIPAggProperty);
            const tipologiaAssicurazioneCode = get("code", codes.tipologiaAssicurazioneProperty);
            const tipologiaAssicurazioneValue = get("value", codes.tipologiaAssicurazioneProperty);
            const premioTipologiaValues = get("values", codes.premioTipologiaProperty);
            const premioDesc = get("value", codes.premioDescProperty);
            const frazPremioValue = get("value", codes.frazPremioProperty);
            const frazPremioValues = get("values", codes.frazPremioProperty);
            const durata = get("value", codes.durataProperty);
            const etaMaxAllaSottoscrizioneValue = get("value", codes.etaMaxAllaSottoscrizioneProperty);
            const etaMaxAllaSottoscrizioneValueSign = get("valueSign", codes.etaMaxAllaSottoscrizioneProperty);
            const etaMaxAllaScadenzaValue = get("value", codes.etaMaxAllaScadenzaProperty);
            const etaMaxAllaScadenzaValueSign = get("valueSign", codes.etaMaxAllaScadenzaProperty);
            const documentazioneRichiesta = get("value", codes.docRichiestaProperty);
            const rischiAssicuratiRamoVitaValue = get("value", codes.rischiAssicuratiRamoVitaProperty);
            const rischiAssicuratiRamoVitaValues = get("values", codes.rischiAssicuratiRamoVitaProperty);
            const rischiAssicuratiRamoDanniValue = get("value", codes.rischiAssicuratiRamoDanniProperty);
            const rischiAssicuratiRamoDanniValues = get("values", codes.rischiAssicuratiRamoDanniProperty);
            const decessoQualsiasiCausaCode = get("code", codes.decessoQualsiasiCausaProperty);
            const decessoQualsiasiCausaValue = get("value", codes.decessoQualsiasiCausaProperty);
            const decessoQualsiasiCausaPrestazione = get("value", codes.decessoQualsiasiCausaPrestazioneProperty);
            const decessoDaInfortunioCode = get("code", codes.decessoDaInfortunioProperty);
            const decessoDaInfortunioValue = get("value", codes.decessoDaInfortunioProperty);
            const decessoDaInfortunioPrestazione = get("value", codes.decessoDaInfortunioPrestazioneProperty);
            const decessoDaMalattiaCode = get("code", codes.decessoDaMalattiaProperty);
            const decessoDaMalattiaValue = get("value", codes.decessoDaMalattiaProperty);
            const decessoDaMalattiaPrestazione = get("value", codes.decessoDaMalattiaPrestazioneProperty);
            const invaliditaPermanenteQualsiasiCausaCode = get("code", codes.invaliditaPermanenteQualsiasiCausaProperty);
            const invaliditaPermanenteQualsiasiCausaValue = get("value", codes.invaliditaPermanenteQualsiasiCausaProperty);
            const invaliditaPermanenteQualsiasiCausaPrestazione = get("value", codes.invaliditaPermanenteQualsiasiCausaPrestazioneProperty);
            const invaliditaPermanenteDaInfortunioCode = get("code", codes.invaliditaPermanenteDaInfortunioProperty);
            const invaliditaPermanenteDaInfortunioValue = get("value", codes.invaliditaPermanenteDaInfortunioProperty);
            const invaliditaPermanenteDaInfortunioPrestazione = get("value", codes.invaliditaPermanenteDaInfortunioPrestazioneProperty);
            const invaliditaPermanenteDaMalattiaCode = get("code", codes.invaliditaPermanenteDaMalattiaProperty);
            const invaliditaPermanenteDaMalattiaValue = get("value", codes.invaliditaPermanenteDaMalattiaProperty);
            const invaliditaPermanenteDaMalattiaPrestazione = get("value", codes.invaliditaPermanenteDaMalattiaPrestazioneProperty);
            const inabilitaTemporaneaQualsiasiCausaCode = get("code", codes.inabilitaTemporaneaQualsiasiCausaProperty);
            const inabilitaTemporaneaQualsiasiCausaValue = get("value", codes.inabilitaTemporaneaQualsiasiCausaProperty);
            const inabilitaTemporaneaQualsiasiCausaPrestazione = get("value", codes.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty);
            const inabilitaTemporaneaDaInfortunioCode = get("code", codes.inabilitaTemporaneaDaInfortunioProperty);
            const inabilitaTemporaneaDaInfortunioValue = get("value", codes.inabilitaTemporaneaDaInfortunioProperty);
            const inabilitaTemporaneaDaInfortunioPrestazione = get("value", codes.inabilitaTemporaneaDaInfortunioPrestazioneProperty);
            const inabilitaTemporaneaDaMalattiaCode = get("code", codes.inabilitaTemporaneaDaMalattiaProperty);
            const inabilitaTemporaneaDaMalattiaValue = get("value", codes.inabilitaTemporaneaDaMalattiaProperty);
            const inabilitaTemporaneaDaMalattiaPrestazione = get("value", codes.inabilitaTemporaneaDaMalattiaPrestazioneProperty);
            const malattieGraviCode = get("code", codes.malattieGraviProperty);
            const malattieGraviValue = get("value", codes.malattieGraviProperty);
            const malattieGraviPrestazione = get("value", codes.malattieGraviPrestazioneProperty);
            const ricoveroOspedalieroCode = get("code", codes.ricoveroOspedalieroProperty);
            const ricoveroOspedalieroValue = get("value", codes.ricoveroOspedalieroProperty);
            const ricoveroOspedalieroPrestazione = get("value", codes.ricoveroOspedalieroPrestazioneProperty);
            const ricoveroGrandeInterventoChirurgicoCode = get("code", codes.ricoveroGrandeInterventoChirurgicoProperty);
            const ricoveroGrandeInterventoChirurgicoValue = get("value", codes.ricoveroGrandeInterventoChirurgicoProperty);
            const ricoveroGrandeInterventoChirurgicoPrestazione = get("value", codes.ricoveroGrandeInterventoChirurgicoPrestazioneProperty);
            const perditaImpiegoCode = get("code", codes.perditaImpiegoProperty);
            const perditaImpiegoValue = get("value", codes.perditaImpiegoProperty);
            const perditaImpiegoPrestazione = get("value", codes.perditaImpiegoPrestazioneProperty);
            const altriRischi = get("value", codes.altriRischiProperty);
            const speseEmissione = get("value", codes.speseEmissioneProperty);
            const speseEmissioneValueSign = get("valueSign", codes.speseEmissioneProperty);
            const costiRamoVitaValue = get("value", codes.costiRamoVitaProperty);
            const costiRamoVitaValueStringList = get("stringList", codes.costiRamoVitaProperty);
            const costiRamoDanniValue = get("value", codes.costiRamoDanniProperty);
            const costiRamoDanniValueStringList = get("stringList", codes.costiRamoDanniProperty);
            const specificheCaricamenti = get("value", codes.specificheCaricamentiProperty);
            const interessiFrazValue = get("value", codes.interessiFrazProperty);
            const interessiFrazFrazionamento = get("frazionamento", codes.interessiFrazProperty);
            const altriCosti = get("value", codes.altriCostiProperty);
            const retrDistribRamoVitaValue = get("value", codes.retrDistrVitaProperty);
            const retrDistribRamoVitaValueSign = get("valueSign", codes.retrDistrVitaProperty);
            const retrDistribRamoDanniValue = get("value", codes.retrDistrDanniProperty);
            const retrDistribRamoDanniValueSign = get("valueSign", codes.retrDistrDanniProperty);
            const retrDistrSpecifiche = get("value", codes.retrDistrSpecificheProperty);
            const note = get("value", codes.noteProperty);

            // prodotto
            properties.prodottoProperty.value = prodotto;
            // piuTariffe
            selectChoices.piuTariffe = vm.prefillCodeValue(properties.piuTariffeProperty, piuTariffeCode, piuTariffeValue, selectChoices.piuTariffe, vm.piuTariffeOptions);            
            // prodotti collegati
            properties.codProdCollegatoProperty.value = codProdottiCollegati;
            // compagnia
            selectChoices.compagnia = vm.prefillValues(properties.compagniaProperty, compagniaValues, selectChoices.compagnia, vm.compagniaOptions);
            // canale
            selectChoices.canale = vm.prefillValues(properties.canaleProperty,canaleValues,selectChoices.canale,vm.canaleOptions);
            // distributori
            properties.distributoriProperty.stringList = distributoriStringList;
            // modalità di distribuzione
            selectChoices.modDistribuzione = vm.prefillValues(properties.modDistribuzioneProperty,modDistribuzioneValues,selectChoices.modDistribuzione,vm.modDistribuzioneOptions);
            // mercato
            selectChoices.mercato = vm.prefillValues(properties.mercatoProperty,mercatoValues,selectChoices.mercato,vm.mercatoOptions);
            // destinatari
            properties.destinatariProperty.value = destinatari;
            // target market
            properties.targetMarketProperty.value = targetMarket;
            // desc prodotto
            properties.descProdottoProperty.value = descProdotto;
            // linea business
            properties.lineaBusinessProperty.value = lineaBusiness;
            // ramo
            selectChoices.ramo = vm.prefillValues(properties.ramoProperty,ramoValues,selectChoices.ramo,vm.ramoOptions);
            // tipologia garanzie
            selectChoices.tipologiaGaranzie = vm.prefillValues(properties.tipologiaGaranzieProperty,tipologiaGaranzieValues,selectChoices.tipologiaGaranzie,vm.tipologiaGaranzieOptions);
            // combinazione garanzie
            properties.combinazioneGaranzieProperty.value = combinazioneGaranzie;
            // prodotto in commercio
            selectChoices.prodCommercio = vm.prefillCodeValue(properties.prodCommercioProperty, prodCommercioCode, prodCommercioValue, selectChoices.prodCommercio, vm.prodCommercioOptions);
            // inizio commercializzazione
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            // fine commercializzazione
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            // edizione DIP aggiuntivo
            properties.edizioneDIPAggProperty.value = edizioneDIPAgg;
            properties.edizioneDIPAggProperty.dateValue = vm.dateFromString(edizioneDIPAgg);
            // tipologia di assicurazione
            selectChoices.tipologiaAssicurazione = vm.prefillCodeValue(properties.tipologiaAssicurazioneProperty, tipologiaAssicurazioneCode, tipologiaAssicurazioneValue, selectChoices.tipologiaAssicurazione, vm.tipologiaAssicurazioneOptions);
            // premio - tipologia
            selectChoices.premioTipologia = vm.prefillValues(properties.premioTipologiaProperty,premioTipologiaValues,selectChoices.premioTipologia,vm.premioTipologiaOptions);
            // premio - descrizione
            properties.premioDescProperty.value = premioDesc;
            // frazionamento del premio
            properties.frazPremioProperty.value = frazPremioValue;
            selectChoices.frazPremio = vm.prefillValues(properties.frazPremioProperty,frazPremioValues,selectChoices.frazPremio,vm.frazPremioOptions);
            // durata contrattuale
            properties.durataProperty.value = durata;
            // età massima alla sottoscrizione
            properties.etaMaxAllaSottoscrizioneProperty.value = etaMaxAllaSottoscrizioneValue;
            properties.etaMaxAllaSottoscrizioneProperty.valueSign = etaMaxAllaSottoscrizioneValueSign;
            // età massima alla scadenza
            properties.etaMaxAllaScadenzaProperty.value = etaMaxAllaScadenzaValue;
            properties.etaMaxAllaScadenzaProperty.valueSign = etaMaxAllaScadenzaValueSign;
            // documentazione richiesta
            properties.docRichiestaProperty.value = documentazioneRichiesta;
            // rischi assicurati ramo vita
            properties.rischiAssicuratiRamoVitaProperty.value = rischiAssicuratiRamoVitaValue;
            selectChoices.rischiAssicuratiRamoVita = vm.prefillValues(properties.rischiAssicuratiRamoVitaProperty,rischiAssicuratiRamoVitaValues,selectChoices.rischiAssicuratiRamoVita,vm.rischiAssicuratiRamoVitaOptions);
            // rischi assicurati ramo danni
            properties.rischiAssicuratiRamoDanniProperty.value = rischiAssicuratiRamoDanniValue;
            selectChoices.rischiAssicuratiRamoDanni = vm.prefillValues(properties.rischiAssicuratiRamoDanniProperty,rischiAssicuratiRamoDanniValues,selectChoices.rischiAssicuratiRamoDanni,vm.rischiAssicuratiRamoDanniOptions);
            // decesso qualsiasi causa
            selectChoices.decessoQualsiasiCausa = vm.prefillCodeValue(properties.decessoQualsiasiCausaProperty, decessoQualsiasiCausaCode, decessoQualsiasiCausaValue, selectChoices.decessoQualsiasiCausa, vm.decessoQualsiasiCausaOptions);
            // decesso qualsiasi causa - prestazione
            properties.decessoQualsiasiCausaPrestazioneProperty.value = decessoQualsiasiCausaPrestazione;
            // decesso da infortunio
            selectChoices.decessoDaInfortunio = vm.prefillCodeValue(properties.decessoDaInfortunioProperty, decessoDaInfortunioCode, decessoDaInfortunioValue, selectChoices.decessoDaInfortunio, vm.decessoDaInfortunioOptions);
            // decesso da infortunio - prestazione
            properties.decessoDaInfortunioPrestazioneProperty.value = decessoDaInfortunioPrestazione;
            // decesso da malattia
            selectChoices.decessoDaMalattia = vm.prefillCodeValue(properties.decessoDaMalattiaProperty, decessoDaMalattiaCode, decessoDaMalattiaValue, selectChoices.decessoDaMalattia, vm.decessoDaMalattiaOptions);
            // decesso da malattia - prestazione
            properties.decessoDaMalattiaPrestazioneProperty.value = decessoDaMalattiaPrestazione;
            // invalidità permanente qualsiasi causa
            selectChoices.invaliditaPermanenteQualsiasiCausa = vm.prefillCodeValue(properties.invaliditaPermanenteQualsiasiCausaProperty, invaliditaPermanenteQualsiasiCausaCode, invaliditaPermanenteQualsiasiCausaValue, selectChoices.invaliditaPermanenteQualsiasiCausa, vm.invaliditaPermanenteQualsiasiCausaOptions);
            // invalidità permanente qualsiasi causa - prestazione
            properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty.value = invaliditaPermanenteQualsiasiCausaPrestazione;
            // invalidità permanente da infortunio
            selectChoices.invaliditaPermanenteDaInfortunio = vm.prefillCodeValue(properties.invaliditaPermanenteDaInfortunioProperty, invaliditaPermanenteDaInfortunioCode, invaliditaPermanenteDaInfortunioValue, selectChoices.invaliditaPermanenteDaInfortunio, vm.invaliditaPermanenteDaInfortunioOptions);
            // invalidità permanente da infortunio - prestazione
            properties.invaliditaPermanenteDaInfortunioPrestazioneProperty.value = invaliditaPermanenteDaInfortunioPrestazione;
            // invalidità permanente da malattia
            selectChoices.invaliditaPermanenteDaMalattia = vm.prefillCodeValue(properties.invaliditaPermanenteDaMalattiaProperty, invaliditaPermanenteDaMalattiaCode, invaliditaPermanenteDaMalattiaValue, selectChoices.invaliditaPermanenteDaMalattia, vm.invaliditaPermanenteDaMalattiaOptions);
            // invalidità permanente da malattia - prestazione
            properties.invaliditaPermanenteDaMalattiaPrestazioneProperty.value = invaliditaPermanenteDaMalattiaPrestazione;
            // inabilità temporanea qualsiasi causa
            selectChoices.inabilitaTemporaneaQualsiasiCausa = vm.prefillCodeValue(properties.inabilitaTemporaneaQualsiasiCausaProperty, inabilitaTemporaneaQualsiasiCausaCode, inabilitaTemporaneaQualsiasiCausaValue, selectChoices.inabilitaTemporaneaQualsiasiCausa, vm.inabilitaTemporaneaQualsiasiCausaOptions);
            // inabilità temporanea qualsiasi causa - prestazione
            properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty.value = inabilitaTemporaneaQualsiasiCausaPrestazione;
            // inabilità temporanea da infortunio
            selectChoices.inabilitaTemporaneaDaInfortunio = vm.prefillCodeValue(properties.inabilitaTemporaneaDaInfortunioProperty, inabilitaTemporaneaDaInfortunioCode, inabilitaTemporaneaDaInfortunioValue, selectChoices.inabilitaTemporaneaDaInfortunio, vm.inabilitaTemporaneaDaInfortunioOptions);
            // inabilità temporanea da infortunio - prestazione
            properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty.value = inabilitaTemporaneaDaInfortunioPrestazione;
            // inabilità temporanea da malattia
            selectChoices.inabilitaTemporaneaDaMalattia = vm.prefillCodeValue(properties.inabilitaTemporaneaDaMalattiaProperty, inabilitaTemporaneaDaMalattiaCode, inabilitaTemporaneaDaMalattiaValue, selectChoices.inabilitaTemporaneaDaMalattia, vm.inabilitaTemporaneaDaMalattiaOptions);
            // inabilità temporanea da malattia - prestazione
            properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty.value = inabilitaTemporaneaDaMalattiaPrestazione;
            // malattie gravi
            selectChoices.malattieGravi = vm.prefillCodeValue(properties.malattieGraviProperty, malattieGraviCode, malattieGraviValue, selectChoices.malattieGravi, vm.malattieGraviOptions);
            // malattie gravi - prestazione
            properties.malattieGraviPrestazioneProperty.value = malattieGraviPrestazione;
            // ricovero ospedaliero
            selectChoices.ricoveroOspedaliero = vm.prefillCodeValue(properties.ricoveroOspedalieroProperty, ricoveroOspedalieroCode, ricoveroOspedalieroValue, selectChoices.ricoveroOspedaliero, vm.ricoveroOspedalieroOptions);
            // ricovero ospedaliero - prestazione
            properties.ricoveroOspedalieroPrestazioneProperty.value = ricoveroOspedalieroPrestazione;
            // ricovero grande intervento chirurgico
            selectChoices.ricoveroGrandeInterventoChirurgico = vm.prefillCodeValue(properties.ricoveroGrandeInterventoChirurgicoProperty, ricoveroGrandeInterventoChirurgicoCode, ricoveroGrandeInterventoChirurgicoValue, selectChoices.ricoveroGrandeInterventoChirurgico, vm.ricoveroGrandeInterventoChirurgicoOptions);
            // ricovero grande intervento chirurgico - prestazione
            properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty.value = ricoveroGrandeInterventoChirurgicoPrestazione;
            // perdita impiego
            selectChoices.perditaImpiego = vm.prefillCodeValue(properties.perditaImpiegoProperty, perditaImpiegoCode, perditaImpiegoValue, selectChoices.perditaImpiego, vm.perditaImpiegoOptions);
            // perdita impiego - prestazione
            properties.perditaImpiegoPrestazioneProperty.value = perditaImpiegoPrestazione;
            // altri rischi
            properties.altriRischiProperty.value = altriRischi;
            // spese emissione
            properties.speseEmissioneProperty.value = speseEmissione;
            properties.speseEmissioneProperty.valueSign = speseEmissioneValueSign;
            if (speseEmissione !== vm.ND && (speseEmissione === undefined || speseEmissione === null) && (speseEmissioneValueSign === undefined || speseEmissioneValueSign === null)) {
              properties.speseEmissioneProperty.value = "";
              properties.speseEmissioneProperty.valueSign = "€";
            }
            // costi ramo vita
            properties.costiRamoVitaProperty.value = costiRamoVitaValue;
            properties.costiRamoVitaProperty.stringList = costiRamoVitaValueStringList;
            if (costiRamoVitaValue !== vm.ND && (costiRamoVitaValueStringList === undefined || costiRamoVitaValueStringList === null)) {
              properties.costiRamoVitaProperty.value = "";
              properties.costiRamoVitaProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];              
            }
            // costi ramo danni
            properties.costiRamoDanniProperty.value = costiRamoDanniValue;
            properties.costiRamoDanniProperty.stringList = costiRamoDanniValueStringList;
            if (costiRamoDanniValue !== vm.ND && (costiRamoDanniValueStringList === undefined || costiRamoDanniValueStringList === null)) {
              properties.costiRamoDanniProperty.value = "";
              properties.costiRamoDanniProperty.stringList = [{ value: "", valueSign: "%", valueLabel: "Min." },{ value: "", valueSign: "%", valueLabel: "Max." }];              
            }
            // specifiche caricamenti
            properties.specificheCaricamentiProperty.value = specificheCaricamenti;
            // interessi di frazionamento
            properties.interessiFrazProperty.value = interessiFrazValue;
            properties.interessiFrazProperty.frazionamento = interessiFrazFrazionamento;
            // altri costi
            properties.altriCostiProperty.value = altriCosti;
            // retrocessione alla distribuzione ramo vita
            properties.retrDistrVitaProperty.value = retrDistribRamoVitaValue;
            properties.retrDistrVitaProperty.valueSign = retrDistribRamoVitaValueSign;
            // retrocessione alla distribuzione ramo vita
            properties.retrDistrDanniProperty.value = retrDistribRamoDanniValue;
            properties.retrDistrDanniProperty.valueSign = retrDistribRamoDanniValueSign;
            // retrocessione alla distribuzione specifiche
            properties.retrDistrSpecificheProperty.value = retrDistrSpecifiche;
            // note
            properties.noteProperty.value = note;
          })
          .catch(() => {
            vm.openModalError();
          })

        vm.stopLoading();
      } else {
        // valori fissi
        properties.lineaBusinessProperty.value = "Protezione Credito/Pagamenti/Entrate";

        // change
        vm.changePiuTariffe();
        vm.changeFineComm();
        vm.changePremioTipologia();
        vm.changeRamo();
        vm.changeFrazPremio();
        vm.changeRischiAssicurati();
      }

      vm.initSettingRamo();
    },
    setDatePropertiesValue() {
      const vm = this as any;

      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommercioProperty.code == "16.2" || properties.prodCommercioProperty.code == "") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      properties.edizioneDIPAggProperty.value = vm.formatDate(properties.edizioneDIPAggProperty.dateValue);
    },
    preparePropList() {
      const vm = this as any;

      Vue.set(properties.costiRamoVitaProperty, 'nodashed', true);
      Vue.set(properties.costiRamoDanniProperty, 'nodashed', true);

      vm.setDatePropertiesValue();

      vm.propList = [
        properties.prodottoProperty,
        properties.piuTariffeProperty,
        properties.codProdCollegatoProperty,
        properties.compagniaProperty,
        properties.canaleProperty,
        properties.distributoriProperty,
        properties.modDistribuzioneProperty,
        properties.mercatoProperty,
        properties.destinatariProperty,
        properties.targetMarketProperty,
        properties.descProdottoProperty,
        properties.lineaBusinessProperty,
        properties.ramoProperty,
        properties.tipologiaGaranzieProperty,
        properties.combinazioneGaranzieProperty,
        properties.prodCommercioProperty,
        properties.inizioCommProperty,
        properties.fineCommProperty,
        properties.edizioneDIPAggProperty,
        properties.tipologiaAssicurazioneProperty,
        properties.premioTipologiaProperty,
        properties.premioDescProperty,
        properties.frazPremioProperty,
        properties.durataProperty,
        properties.etaMaxAllaSottoscrizioneProperty,
        properties.etaMaxAllaScadenzaProperty,
        properties.docRichiestaProperty,
        properties.rischiAssicuratiRamoVitaProperty,
        properties.rischiAssicuratiRamoDanniProperty,
        properties.decessoQualsiasiCausaProperty,
        properties.decessoQualsiasiCausaPrestazioneProperty,
        properties.decessoDaInfortunioProperty,
        properties.decessoDaInfortunioPrestazioneProperty,
        properties.decessoDaMalattiaProperty,
        properties.decessoDaMalattiaPrestazioneProperty,
        properties.invaliditaPermanenteQualsiasiCausaProperty,
        properties.invaliditaPermanenteQualsiasiCausaPrestazioneProperty,
        properties.invaliditaPermanenteDaInfortunioProperty,
        properties.invaliditaPermanenteDaInfortunioPrestazioneProperty,
        properties.invaliditaPermanenteDaMalattiaProperty,
        properties.invaliditaPermanenteDaMalattiaPrestazioneProperty,
        properties.inabilitaTemporaneaQualsiasiCausaProperty,
        properties.inabilitaTemporaneaQualsiasiCausaPrestazioneProperty,
        properties.inabilitaTemporaneaDaInfortunioProperty,
        properties.inabilitaTemporaneaDaInfortunioPrestazioneProperty,
        properties.inabilitaTemporaneaDaMalattiaProperty,
        properties.inabilitaTemporaneaDaMalattiaPrestazioneProperty,
        properties.malattieGraviProperty,
        properties.malattieGraviPrestazioneProperty,
        properties.ricoveroOspedalieroProperty,
        properties.ricoveroOspedalieroPrestazioneProperty,
        properties.ricoveroGrandeInterventoChirurgicoProperty,
        properties.ricoveroGrandeInterventoChirurgicoPrestazioneProperty,
        properties.perditaImpiegoProperty,
        properties.perditaImpiegoPrestazioneProperty,
        properties.altriRischiProperty,
        properties.speseEmissioneProperty,
        properties.costiRamoVitaProperty,
        properties.costiRamoDanniProperty,
        properties.specificheCaricamentiProperty,
        properties.interessiFrazProperty,
        properties.altriCostiProperty,
        properties.retrDistrVitaProperty,
        properties.retrDistrDanniProperty,
        properties.retrDistrSpecificheProperty,
        properties.noteProperty,
      ];
    },
    printStringListItem(item: any) {
      return (item.valueLabel !== undefined && item.valueLabel !== null && item.valueLabel !== "" ? item.valueLabel + " " : "") + item.value + item.valueSign
    },
    selectedFile: function(fileList: any[]) {
      if (!fileList.length) return;
      this.massiveFile = fileList[0];
    },
    uploadMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.uploadMassive(categories.CPI_PPI, vm.massiveFile)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          if (result !== undefined) {
            vm.massiveLoaded = true;
            vm.massiveResult = result;
          } else {
            vm.closeModalMassivo();
            vm.openModalError("Non è stato possibile caricare il file.");
          }
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile caricare il file.");
        });
    },
    confirmMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.confirmMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Prodotti caricati.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.openModalError("Non è stato possibile confermare i dati caricati.");
        });
    },
    deleteMassive: async function() {
      const vm = this as any;
      vm.startLoading();
      requestService.deleteMassive(vm.massiveResult.massiveId)
        .then(handleResponse)
        .then((result: any) => {
          vm.stopLoading();
          vm.closeModalMassivo();
          vm.openModalError("Caricamento massivo annullato.", "OK"); // non è un errore, sfrutto per aprire la modale
        })
        .catch(() => {
          vm.stopLoading();
          vm.closeModalMassivo();
        });
    },
    printVersatileValues(property: any) {
      const vm = this as any;

      const noDashed = (property.nodashed === undefined || property.nodashed === null) ? false : property.nodashed;

      let isPrintStringList = false;
      if (property.type == propertyTypes.STRING_LIST) {
        isPrintStringList = true;
      } else if (property.stringList !== undefined && property.stringList !== null) {
        if (property.stringList.length > 0) {
          isPrintStringList = true;
        }
      }

      let printableValue = "";
      let tooltipValue = "";
      if (property.type == propertyTypes.VALUES) {
        if (property.values.length > 0) {
          //property.values.sort(vm._compare);
          if (property.values.length == 1) {
            const item = property.values[0];
            printableValue = item.description;
          } else {
            const maxLi = 3;
            let liCounter = 0;
            let li = "";
            // printableValue & tooltipValue
            const tooltipLi = property.values.map(function(item: any) {
              //li is a subset of what in tooltipLi (all)
              liCounter++;
              if (liCounter < maxLi) {
                li += "<li>" + item.description + "</li>";
              } else if (liCounter == maxLi) {
                li += "<li>" + '...' + "</li>";
              }
              return "<li>" + item.description + "</li>";
            }).join("");

            printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
            if (liCounter >= maxLi) {
              tooltipValue = "<div><ul class='dashed'>" + tooltipLi + "</ul></div>";
            }
          }
        } else {
          printableValue = property.value;
        }
      } else if (isPrintStringList) {
        if (property.value !== "") {
          printableValue = property.value;
        } else if (property.stringList.length == 1) {
          const item = property.stringList[0];
          printableValue = vm.printStringListItem(item);
        } else if (noDashed === undefined || !noDashed) {
          const maxLi = 3;
          let liCounter = 0;
          let li = "";
          // printableValue & tooltipValue
          const tooltipLi = property.stringList.map(function(item: any) {
            //li is a subset of what in tooltipLi (all)
            let valueLabel = (item.valueLabel !== undefined && !vm.isEmptyOrSpaces(item.valueLabel) ) ? item.valueLabel + " " : "";
            liCounter++;
            if (liCounter < maxLi) {
              li += "<li>" + valueLabel + item.value + item.valueSign + "</li>";
            } else if (liCounter == maxLi) {
              li += "<li>" + '...' + "</li>";
            }
            return "<li>" + valueLabel + item.value + item.valueSign + "</li>";
          }).join("");

          printableValue = "<div><ul class='dashed'>" + li + "</ul></div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"dashed\">" + tooltipLi + "</ul></div>";
          }
        } else if (noDashed) {
          let equalValues = (property.stringList.length == 2 && property.stringList[0].value == property.stringList[1].value && property.stringList[0].valueSign == property.stringList[1].valueSign && property.name != "Rendimento Gestione Separata");
          if (equalValues) {
            if (property.stringList[0].valueSignLeft) {
              printableValue = property.stringList[0].valueSign + " " + property.stringList[0].value;
            } else {
              printableValue = property.stringList[0].value + property.stringList[0].valueSign;
            }
          } else {
            const li = property.stringList.map(function(item: any) {
              return "<li>" + vm.printStringListItem(item) + "</li>";
            }).join("");
            printableValue = "<ul class='nodashed'>" + li + "</ul>";
          }
        }
      } else if (property.type == propertyTypes.RANGE_FLEX) {
        let isNestedRangeValuesFlex = false;

        if (property.rangeValuesFlex.length > 0) {
          const maxLi = 3;
          let liCounter = 0;
          let liItemsPV = "";
          let liItemsTV = "";
          property.rangeValuesFlex.forEach((item: any) => {
            liCounter++;

            const label = (item.label !== undefined && !vm.isEmptyOrSpaces(item.label)) ? item.label + " " : "";

            const spacingFrom = item.fromSignLeft || item.fromSign.indexOf('ann') >= 0 ? ' ' : '';
            const from = item.fromSignLeft ? item.fromSign + spacingFrom + item.from : item.from + spacingFrom + item.fromSign;
            
            const spacingTo = item.toSignLeft || item.toSign.indexOf('ann') >= 0 ? ' ' : '';
            const to = item.toSignLeft ? item.toSign + spacingTo + item.to : item.to + spacingTo + item.toSign;

            let value = undefined;
            if (item.showValue) {
              const spacingValue = item.valueSignLeft || item.valueSign.indexOf('ann') >= 0 ? ' ' : '';
              value = item.valueSignLeft ? item.valueSign + spacingValue + item.value : item.value + spacingValue + item.valueSign;
            }
            // liItem
            let liItem =  label + from + " " + item.fromToOperator + " " + to;
            if (value !== undefined) {
              liItem +=  " " + item.toValueOperator + " " + value;
            }
            // printableValue
            if (liCounter < maxLi) {
              liItemsPV += "<li>" + liItem + "</li>";
            } else if (liCounter == maxLi) {
              liItemsPV += "<li>" + '...' + "</li>";
            }
            // tooltipValue
            liItemsTV += "<li>" + liItem + "</li>";

            // L2
            let liItemsPVL2 = "";
            let liItemsTVL2 = "";
            const noDashSpace = "&nbsp;&nbsp;&nbsp;&nbsp;";
            if (item.rangeValuesFlex !== undefined && item.rangeValuesFlex !== null) {
              if (item.rangeValuesFlex.length > 0) {
                isNestedRangeValuesFlex = true;

                item.rangeValuesFlex.forEach(function(itemL2: any) {
                  liCounter++;

                  const isLabelL2 = (itemL2.label !== undefined && !vm.isEmptyOrSpaces(itemL2.label));
                  const labelL2 = isLabelL2 ? "-&nbsp;&nbsp;" + itemL2.label + " " : "";

                  const spacingFromL2 = itemL2.fromSignLeft || itemL2.fromSign.indexOf('ann') >= 0 ? ' ' : '';
                  const fromL2 = itemL2.fromSignLeft ? itemL2.fromSign + spacingFromL2 + itemL2.from : itemL2.from + spacingFromL2 + itemL2.fromSign;

                  const spacingToL2 = itemL2.toSignLeft || itemL2.toSign.indexOf('ann') >= 0 ? ' ' : '';
                  const toL2 = itemL2.toSignLeft ? itemL2.toSign + spacingToL2 + itemL2.to : itemL2.to + spacingToL2 + itemL2.toSign;

                  let valueL2 = undefined;
                  if (itemL2.showValue) {
                    const spacingValueL2 = itemL2.valueSignLeft || itemL2.valueSign.indexOf('ann') >= 0 ? ' ' : '';
                    valueL2 = itemL2.valueSignLeft ? itemL2.valueSign + spacingValueL2 + itemL2.value : itemL2.value + spacingValueL2 + itemL2.valueSign;
                  }
                  let liItemL2 = fromL2 + " " + itemL2.fromToOperator + " " + toL2;
                  if (valueL2 !== undefined) {
                    liItemL2 +=  " " + itemL2.toValueOperator + " " + valueL2;
                  }
                  // printableValue L2
                  if (liCounter < maxLi) {
                    if (isLabelL2 && liCounter < maxLi) {
                      liItemsPVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                      liCounter++;
                    }
                  }
                  if (liCounter < maxLi) {
                    liItemsPVL2 += "<li>" + noDashSpace + liItemL2 + "</li>";
                  } else if (liCounter == maxLi) {
                    liItemsPVL2 += "<li>" + '...' + "</li>";
                  }
                  // tooltipValue L2
                  liItemsTVL2 += isLabelL2 ? "<li>" + labelL2 + "</li>" : "";
                  liItemsTVL2 += "<li>" + noDashSpace + liItemL2 + "</li>";
                });

                liItemsPV += "<div><ul class='nodashed'>" + liItemsPVL2 + "</ul></div>";

                liItemsTV += "<div><ul class=\"nodashed\">" + liItemsTVL2 + "</ul></div>";
              }
            }
          });

          let dashClass = "nodashed";
          if (isNestedRangeValuesFlex) {
            dashClass = "dashed";
          }

          printableValue = "<div><ul class='" + dashClass +  "'>" + liItemsPV + "</ul></div>";
          if (liCounter >= maxLi) {
            tooltipValue = "<div><ul class=\"" + dashClass + "\">" + liItemsTV + "</ul></div>";
          }
        } else {
          if (property.valueSign !== undefined && property.valueSign !== null) {
            if (property.valueSign.length > 0) {
              printableValue = property.value + property.valueSign;
            }
          }
          if (printableValue === undefined || vm.isEmptyOrSpaces(printableValue)) {
            printableValue = property.value;
          }
        }
      } else if (property.type == propertyTypes.DATE) {
        const d = vm.dateFromString(property.value);
        if (d != null) {
          printableValue = vm.formatDateF(d, "MM/yyyy");
        } else {
          printableValue = property.value;
        }
      } else {
        const maxCharsPerRow = 40;
        const maxRows = 1;
        let printedRows = 0;
        let flagDots = false;
        if (property.value !== undefined && property.value !== null) {
          if (property.value.length > maxCharsPerRow) {

            for (let i = 0; i < property.value.length && printedRows < maxRows;) {
              let endIndex = Math.min(i+maxCharsPerRow, property.value.length);
              let dots = "";
              if (printedRows+1 == maxRows) {
                dots = "...";
                flagDots = true;
              }
              printableValue += "<div>" + property.value.substring(i, endIndex) + dots + "</div>";
              i += maxCharsPerRow;
              printedRows += 1;
            }

            if (flagDots) {
              tooltipValue = property.value;
            }
          } else {
            if (property.valueSign !== undefined && !vm.isEmptyOrSpaces(property.valueSign)) {
              if (property.valueSign.length > 0) {
                printableValue = property.value + property.valueSign;
              }
            } else {
              printableValue = property.value;
            }
          }
        }
      }

      if (tooltipValue !== undefined && !vm.isEmptyOrSpaces(tooltipValue)) {
        printableValue = tooltipValue;
      }

      printableValue = printableValue.replace(/\n/g, "<br />");

      return printableValue;
    },
    isEmptyOrSpaces(str: string) {
      return str === null || str.match(/^ *$/) !== null;
    },
    //
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesDefaultCode();

        vm.preparePropList();

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: vm.propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      return requestService.initProductWithCategory(categories.CPI_PPI).then(handleResponse);
    },
    _compareDesc: function(a: any, b: any) {
      const aDesc = a.description;
      const bDesc = b.description;
      if (aDesc === undefined || bDesc === undefined) {
        if (bDesc !== undefined) {
          return -1;
        }
        if (aDesc !== undefined) {
          return 1;
        }
        return 0;
      }

      if (aDesc > bDesc) {
        return 1;
      } else {
        return -1;
      }
    },
    isAdmin: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isAdminView = vm.loggedUser.roles.indexOf('admin-view') >= 0;
      return isAdmin || isAdminView;
    },
    massivo: function() {
      const vm = this as any;
      const isAdmin = vm.loggedUser.roles.indexOf('admin') >= 0;
      const isMassivo = vm.loggedUser.roles.indexOf('massivo') >= 0;

      return isAdmin || isMassivo;
    },
  },
  created() {
    const vm = this as any;

    // sort compagnie by desc
    vm.compagniaOptions.sort(vm._compareDesc);

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  mounted() {
    const vm = this as any;
    if (!vm.loggedUser) {
      vm.home();
    } else {
      const hasRole = vm.loggedUser.roles.indexOf('cpi-ppi') >= 0;

      if (!vm.isAdmin() && !hasRole) {
        vm.home();
      }
    }
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  },
});
